import { useTranslation } from 'react-i18next'

const Street = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="street-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="street-title">{t('antagonists:foreigndad:components:background')}</title>
      <defs>
        <clipPath id="street-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="street-c">
          <path
            style={{
              fill: '#344138',
            }}
            d="m1312.92 945.2.02-608.08 465.56-1.17 6.64 619.87-472.22-10.62z"
          />
        </clipPath>
        <clipPath id="street-d">
          <path
            style={{
              fill: '#776baa',
            }}
            d="m84.28 798.74-2.09-593.85 643.52-24.14 5.4 613.35-646.83 4.64z"
          />
        </clipPath>
        <clipPath id="street-e">
          <path
            style={{
              fill: '#62ac6d',
            }}
            d="m423.15 523.97 237.9-4.61 2.86 225.94-251.74 3.02 10.98-224.35z"
          />
        </clipPath>
        <clipPath id="street-f">
          <path
            style={{
              fill: '#efe8f2',
            }}
            d="M128.36 617.22 74.54 774.29l188.7.85 34.29-155.22-169.17-2.7z"
          />
        </clipPath>
        <clipPath id="street-g">
          <path
            style={{
              fill: '#e6eef8',
            }}
            d="m309.3 592.1 34.33 185.4h128.18L432.9 592.1H309.3z"
          />
        </clipPath>
        <clipPath id="street-h">
          <path
            style={{
              fill: '#e53446',
            }}
            d="m34.8 92.1-9.66 114.93 760.23 1.14-9.68-116.11-740.89.04z"
          />
        </clipPath>
        <style>
          {
            '.j{fill:none}.k{fill:#f8dfb3}.l{fill:#009a95}.m{fill:#eeeef0}.n{fill:#f19eb0}.o{fill:#ec7206}.p{fill:#e6eef8}.q{fill:#eaba00}.r{fill:#fae7c6}.s{fill:#fee608}.t{fill:#fbf8f6}.u{fill:#e53446}.v{fill:#fcf6e7}.w{fill:#e52d87}.x{fill:#efe8f2}.y{fill:#8aa195}.aa{fill:#a691c0}.ab{fill:#c3ae7b}.ac{fill:#dedcd1}.ad{fill:#dfbe84}.ae{fill:#425170}.af{fill:#5597c3}.ag{fill:#62ac6d}.ah{fill:#344138}.ai{fill:#272a3e}.aj{fill:#776baa}.ak{clip-path:url(#street-c)}.al{clip-path:url(#street-b)}.am{clip-path:url(#street-f)}.an{clip-path:url(#street-e)}.ao{clip-path:url(#street-d)}.ap{clip-path:url(#street-h)}.aq{clip-path:url(#street-g)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#street-b)',
        }}
        id="street-a"
      >
        <path
          style={{
            fill: '#f8dfb3',
          }}
          d="M-214.6-99.22h2302v1214.71h-2302z"
        />
        <path
          style={{
            fill: '#fae7c6',
          }}
          d="m-183.12 1352.26-14.15-697.94 2306.48 4.45 37.3 710.36-2329.63-16.87z"
        />
        <path
          style={{
            fill: '#c3ae7b',
          }}
          d="m1292.33 937.39-3.47-697.88 517.34.22.59 707.65-514.46-9.99z"
        />
        <path
          style={{
            fill: '#344138',
          }}
          d="m1312.92 945.2.02-608.08 465.56-1.17 6.64 619.87-472.22-10.62z"
        />
        <g
          style={{
            clipPath: 'url(#street-c)',
          }}
        >
          <path
            style={{
              fill: '#5597c3',
            }}
            d="m1351.76 374.68.55 124.03 177.24 1.57-.93-124.1-176.86-1.5zM1564.32 375.77l.55 124.02 180.37-2.45-.93-124.11-179.99 2.54z"
          />
          <path
            style={{
              fill: '#c3ae7b',
            }}
            d="m1544.11 325.55 3.69 684.94 6.15-1.31-4.92-687.57-4.92 3.94z"
          />
        </g>
        <path
          style={{
            fill: '#5597c3',
          }}
          d="m1349.43 510.62.42 292.38 179.92 1.94-.81-292.61-179.53-1.71zM1564.77 512.96l1.28 290.35 181.96-1.62-3.94-288.95-179.3.22z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="m1539.72-312.75 1.64 475.21 313.6 2.26-.89-475.55-314.35-1.92z"
        />
        <path
          style={{
            fill: '#c1d3d7',
          }}
          d="m1560.9-289.18 2.07 420.19 271.92 2.07-1.38-420.53-272.61-1.73z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="m1695.14-291.83-5.87 435.23 16.12.57 4.97-435.98-15.22.18zM1001.42-304.15l1.64 475.21 313.6 2.26-.89-475.55-314.35-1.92z"
        />
        <path
          style={{
            fill: '#c1d3d7',
          }}
          d="m1022.6-280.57 2.07 420.18 271.92 2.07-1.38-420.52-272.61-1.73z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="M1156.84-283.23 1150.97 152l16.12.58 4.97-435.99-15.22.18z"
        />
        <path
          style={{
            fill: '#c3ae7b',
          }}
          d="M60.04 957.53 62 151.73l683.51-2.69 5.7 817.12-691.17-8.63z"
        />
        <path
          style={{
            fill: '#776baa',
          }}
          d="m84.28 798.74-2.09-593.85 643.52-24.14 5.4 613.35-646.83 4.64z"
        />
        <g
          style={{
            clipPath: 'url(#street-d)',
          }}
        >
          <path
            style={{
              fill: '#425170',
            }}
            d="m1.13 612.82 800.95-12.2-6.34 309.91-769.1 18.34L10.62 631.8"
          />
          <path
            style={{
              fill: '#62ac6d',
            }}
            d="m423.15 523.97 237.9-4.61 2.86 225.94-251.74 3.02 10.98-224.35z"
          />
          <g
            style={{
              clipPath: 'url(#street-e)',
            }}
          >
            <path
              style={{
                fill: '#009a95',
              }}
              d="m349.42 546.59 262.86 71.59 79.01 136.75-399.52 21.9 57.65-230.24z"
            />
          </g>
          <path
            style={{
              fill: '#a691c0',
            }}
            d="M-58.94 194.2 746.85 30.56l6.37 278.26L13.21 518.67l-38.13-273.72"
          />
          <path
            style={{
              fill: '#f19eb0',
            }}
            d="M260.89-171.89 786-46.71l-25.89 339.22-543.83-163.52L162.67 8.86l98.22-180.75z"
          />
          <path
            style={{
              fill: '#efe8f2',
            }}
            d="M128.36 617.22 74.54 774.29l188.7.85 34.29-155.22-169.17-2.7z"
          />
          <g
            style={{
              clipPath: 'url(#street-f)',
            }}
          >
            <path
              style={{
                fill: '#fee608',
              }}
              d="m-6.54 697.67 198.25-11.05 87.59 95.45-109.42 70.12-166.4 19.25L-98.34 697.6l91.8.07z"
            />
          </g>
          <path
            style={{
              fill: '#e6eef8',
            }}
            d="m309.3 592.1 34.33 185.4h128.18L432.9 592.1H309.3z"
          />
          <g
            style={{
              clipPath: 'url(#street-g)',
            }}
          >
            <path
              style={{
                fill: '#f19eb0',
              }}
              d="m305.14 712.5 196.54-63.74-14.3-124.73-217.79 8.5 35.55 179.97z"
            />
          </g>
        </g>
        <path
          style={{
            fill: '#e53446',
          }}
          d="m34.8 92.1-9.66 114.93 760.23 1.14-9.68-116.11-740.89.04z"
        />
        <g
          style={{
            clipPath: 'url(#street-h)',
          }}
        >
          <path
            style={{
              fill: '#eaba00',
            }}
            d="m294.56 81.36-1.47 156.75-297.92-9.91L-2.2 79.57l296.76 1.79z"
          />
          <path
            style={{
              fill: '#ec7206',
            }}
            d="m825.29 63.81 11.68 160.48-314.2-15.8 2.63-148.63 299.89 3.95z"
          />
        </g>
        <path
          d="M494.48 125.51s-44.78-.75-56.09-.59c-7.73.12-16.65 4.96-25.11 5.61-8.47-.41-17.53-4.99-25.26-4.87-11.31.17-56.05 2.23-56.05 2.23l.57 8.24s3.14 1.77 3.42 3.58c.29 1.81 3.81 24.65 7.51 28.96 5.37 6.25 12.37 5.59 22.49 6.22 10.12.63 25.42-.12 29.19-8.3 2.76-6 3.88-9.29 8.12-19.58 2.07-5.02 4.92-7.12 9.78-7.2 4.86-.07 8.52 1.94 10.74 6.89 4.55 10.16 5.76 13.41 8.7 19.33 4 8.06 19.32 8.36 29.42 7.44 10.09-.93 17.11-.47 22.29-6.88 3.57-4.42 6.42-27.35 6.66-29.17.23-1.82 3.31-3.68 3.31-3.68l.33-8.25Zm-98.84 20.36c-1.39 6.87-2.38 17.25-10.69 22.01-6.29 3.61-26.3 1.59-30.81.19-4.89-1.51-7.93-5.45-8.77-10.05-.84-4.61-2.1-12.92-2.4-15.48-.29-2.57.2-7.74 4.75-8.54 6.68-1.18 34.6-2.37 42.34-.36 4.5 1.17 6.93 5.46 5.57 12.24Zm88.22-5.4c-.22 2.57-1.24 10.91-1.94 15.54-.7 4.63-3.63 8.65-8.47 10.31-4.46 1.53-24.42 4.13-30.81.71-8.45-4.51-9.74-14.86-11.33-21.69-1.57-6.73.74-11.09 5.21-12.39 7.67-2.24 35.62-1.86 42.33-.88 4.57.67 5.22 5.83 5 8.4Z"
          style={{
            fill: '#fbf8f6',
          }}
        />
        <path
          d="M616.96 497.25c-.48-.24-1.86-.96-2.88-1.14-1.02-.18-10.24-2.2-18.94-2.14-8.7.06-16.55 3.23-17.63 3.41-.56.09-1.44-.13-3.8-.14-2.36 0-3.13.23-3.69.14-1.08-.18-8.93-3.35-17.63-3.41-8.7-.06-17.92 1.96-18.94 2.14s-2.4.9-2.88 1.14c-.48.24-.16 4.37.02 4.55.18.18 2.5.37 3.04.43s1.02.48 1.44 1.8c.42 1.32 1.48 11.31 4.12 14.72 2.13 2.74 5.81 3.41 10.9 3.75 5.45.36 9.75-.21 14.08-4 5.16-4.51 6.52-11.84 6.96-14.34.15-.85 1.09-1.19 2.63-1.22s2.48.37 2.63 1.22c.44 2.5 1.8 9.83 6.96 14.34 4.34 3.79 8.63 4.36 14.08 4 5.09-.33 8.77-1 10.9-3.75 2.64-3.41 3.7-13.4 4.12-14.72.42-1.32.9-1.74 1.44-1.8.54-.06 2.86-.25 3.04-.43s.5-4.31.02-4.55ZM249.82 598.51c-.48-.24-1.86-.96-2.88-1.14-1.02-.18-10.24-2.2-18.94-2.14-8.7.06-16.55 3.23-17.63 3.41-.56.09-1.44-.13-3.8-.14-2.36 0-3.13.23-3.69.14-1.08-.18-8.93-3.35-17.63-3.41-8.7-.06-17.92 1.96-18.94 2.14s-2.4.9-2.88 1.14c-.48.24-.16 4.37.02 4.55.18.18 2.5.37 3.04.43s1.02.48 1.44 1.8c.42 1.32 1.48 11.31 4.12 14.72 2.13 2.74 5.81 3.41 10.9 3.75 5.45.36 9.75-.21 14.08-4 5.16-4.51 6.52-11.84 6.96-14.34.15-.85 1.09-1.19 2.63-1.22 1.54-.03 2.48.37 2.63 1.22.44 2.5 1.8 9.83 6.96 14.34 4.34 3.79 8.63 4.36 14.08 4 5.09-.33 8.77-1 10.9-3.75 2.64-3.41 3.7-13.4 4.12-14.72.42-1.32.9-1.74 1.44-1.8.54-.06 2.86-.25 3.04-.43s.5-4.31.02-4.55Z"
          style={{
            fill: '#272a3e',
          }}
        />
        <path
          d="M411.1 572.99c-.48-.24-1.86-.96-2.88-1.14-1.02-.18-10.24-2.2-18.94-2.14-8.7.06-16.55 3.23-17.63 3.41-.56.09-1.44-.13-3.8-.14-2.36 0-3.13.23-3.69.14-1.08-.18-8.93-3.35-17.63-3.41-8.7-.06-17.92 1.96-18.94 2.14s-2.4.9-2.88 1.14c-.48.24-.16 4.37.02 4.55.18.18 2.5.37 3.04.43s1.02.48 1.44 1.8c.42 1.32 1.48 11.31 4.12 14.72 2.13 2.74 5.81 3.41 10.9 3.75 5.45.36 9.75-.21 14.08-4 5.16-4.51 6.52-11.84 6.96-14.34.15-.85 1.09-1.19 2.63-1.22 1.54-.03 2.48.37 2.63 1.22.44 2.5 1.8 9.83 6.96 14.34 4.34 3.79 8.63 4.36 14.08 4 5.09-.33 8.77-1 10.9-3.75 2.64-3.41 3.7-13.4 4.12-14.72.42-1.32.9-1.74 1.44-1.8.54-.06 2.86-.25 3.04-.43s.5-4.31.02-4.55Z"
          style={{
            fill: '#e52d87',
          }}
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#dedcd1',
          }}
          d="m-181.56 908.54 2287.52-3.83-23.38 321.06-2231.94 147.4-32.2-464.63z"
        />
        <path
          style={{
            fill: '#8aa195',
          }}
          d="m1510.89 703.08 19.57-.28v12.02h-19.85l.28-11.74zM1512.01 621.14l19.57-.28v12.02h-19.85l.28-11.74z"
        />
        <path
          style={{
            fill: '#dfbe84',
          }}
          d="m1501.92 610.55 12.3.51v114.37l-12.82.51.52-115.39z"
        />
        <path
          style={{
            fill: '#8aa195',
          }}
          d="m1579.74 704.14-19.57-.28v12.03h19.85l-.28-11.75zM1578.62 622.21l-19.57-.28v12.02h19.85l-.28-11.74z"
        />
        <path
          style={{
            fill: '#dfbe84',
          }}
          d="m1588.71 611.61-12.3.52V726.5l12.82.51-.52-115.4z"
        />
        <path
          style={{
            fill: '#fcf6e7',
          }}
          d="m1326.55 267.13-.36 48.76 59.07-.5.63-49.87-59.34 1.61z"
        />
        <path
          style={{
            fill: '#272a3e',
          }}
          d="m1336.85 280.41 2.9 4.19 3.58-2.13.07 24.84 6.79.23.3-33.99-5.94-.23-7.7 7.09zM1354.72 280.8l3.66 4.12s3.83-5.38 6.94-3.05c4.06 3.05-8.84 16.61-8.84 16.61l.15 8.38 16.84-.23-.23-6.48-8.61-.38s8.86-10.05 8.55-17.3-5.11-9.42-9.6-9.11c-6.63.46-8.86 7.43-8.86 7.43Z"
        />
      </g>
    </svg>
  )
}

export default Street
